/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Heading, HFlow, Icon } from 'bold-ui'
import { format } from 'date-fns'
import { ToolbarProps } from 'react-big-calendar'

import { dateFnsDefaultLocale } from './agendaLocalizer'
import { AgendaEventModel } from './model'

const dateFormat = "eee, dd 'de' MMMM 'de' yyyy"

export function AgendaToolbar(props: ToolbarProps<AgendaEventModel, object>) {
  const { date, onNavigate } = props
  return (
    <HFlow
      style={css`
        padding: 0.5rem 1rem;
      `}
    >
      <Button type='button' skin='ghost' size='small'>
        <Icon icon='angleLeft' onClick={() => onNavigate('PREV')} />
      </Button>
      <Button type='button' skin='ghost' size='small'>
        <Icon icon='angleRight' onClick={() => onNavigate('NEXT')} />
      </Button>
      <Heading level={2}>{format(date, dateFormat, { locale: dateFnsDefaultLocale }).capitalize()}</Heading>
    </HFlow>
  )
}
